var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import '../../css/components/StudentAnalytics/ViewStudentActivity.css';
// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
import ConceptMasteryBar from './ConceptMasteryBar';
import ActivityRow from './ActivityRow';
var StudentRes = require('../../resources/student');
var AnalyticsRes = require('../../resources/analytics');


const MATH_ID = 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c';
const SCIENCE_ID = '84c52703-3e79-4f8d-8376-d854093843c1';

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;
var ViewStudentActivity = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    // this.setState({
    //   sort: newSort,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    // }, () => {
    //   this.retrieveStudents();
    // });
  },
  getInitialState: function() {
    return {
        _id: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        residentialAddress: '',
        schoolName: '',
        schoolClassName: '',
        SA2Grade: '',
        parentName: '',
        parentNo: '',
        parentEmail: '',
        lastActivityDate: '',
        statusMode: [],
        currentMode: {},
        isLoading: true,
        isGettingConcepts: true,
        concepts: {},
        allTimeStats:{},
        currentCourseInfo: {},
        courseID: MATH_ID,
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
      // conceptsMap: null,
    };
  },
  handleChangeData: function(e) {
    // var update = {};
    // update[field] = e.target.value;
    // this.setState(update);
    // var searchName = this.state.searchStudentName;
    // this.setState({
    //   searchStudentName: e.target.value,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    //   sort: 'firstName'
    // }, () => {
    //   this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
    // });
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();

    var currentURL = window.location.href;
    currentURL = currentURL.split("/");
    var studentID = currentURL[currentURL.length-1]; //get the current class ID
    
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
        _id: studentID,
        isLoading: true,
        statusMode: statusMode,
        currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
      this.retrieveStudent();
    });
  },
  retrieveStudent: function(fName,lName,callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    // var currentURL = window.location.href;
    // currentURL = currentURL.split("/");
    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    options.conditions.sort = this.state.sort || "firstName";
    // options.conditions.status = 'student';
    options.conditions.studentID = studentID;

    // var firstN = '';
    // var lastN = '';
    // if (fName) { firstN = fName; }
    // if (lName) { lastN = lName; }

    // options.conditions.sort = this.state.sort || "dateCreated";
    options.conditions.status = 'student';
    // options.conditions.firstName = firstN;
    // options.conditions.lastName = lastN;
    StudentRes.retrieveStudent(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);

      // console.log("RES IS :" + res.lastName);


        _this.setState({
            _id: studentID,
            // isLoading: false,
            firstName: res.firstName,
            lastName: res.lastName,
            progressPageTitle: res.firstName + " " + res.lastName + "'s Progress",
            email: res.email,
            phone: res.phone,
            residentialAddress: res.metadata.residentialAddress,
            schoolName: res.metadata.school,
            schoolClassName: res.metadata.class,
            SA2Grade: res.metadata.SA2Grade,
            parentName: res.metadata.parentName,
            parentNo: res.metadata.parentNo,
            parentEmail: res.metadata.parentEmail,
            lastActivityDate: '',
            // studentsData: (!err && res) ? res: [{}]
            }, () => {

              _this.retrieveConcepts();
                // var sData = _this.state.studentsData;
                // for (var i = 0; i < sData.length; i++) {

                //     var thisData = sData[i];
                //     var dDate = thisData['lastActivityDate'];
                //     var processDate = new Date(dDate);
                //     var dateToDisplay = processDate.toDateString();
                //     if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                //     thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                // }

                // _this.setState({
                //     studentsData: sData
                // });
            // console.log("DONE!!!");
            }
        );
    })
  },
  daysInMonth: function(iMonth, iYear) {
    return new Date(iYear, iMonth, 0).getDate();
  },
    renderHeaderRows: function() {
      var result = [],
          _this = this;
      
      result.push(<th key={'studentClassName'} className="sortable mbHeader">
              Date
              </th>);
      result.push(<th key={'noOfStudents'} className="sortable mbHeader">
              Concept
              </th>);
      result.push(<th key={'studentClassLevel'} className="sortable mbHeader">
              Worksheet
              </th>);
      result.push(<th key={'type'} className="sortable mbHeader">
              Type
              </th>);
      result.push(<th key={'score'} className="sortable mbHeader">
              Score
              </th>);
      result.push(<th key={'status'} className="sortable mbHeader">
              Status
              </th>);
      return (
          <tr>
          {
              result.map((value, index) => {
              return value
              })
          }
          </tr>
      )
  },
  renderActivityRows: function(fName,lName,callback) {

    callback = callback || function(){};
    var _this = this;

    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = today.getMonth() + 1; //January is 0!
    var dd = today.getDate();//this.daysInMonth(mm,yyyy);//today.getDate(); //get last day for this month

    var result = [];

    for (var i = 0; i < 6; i++) { //get mistakes for last 6 months
      
      if (i > 0) {

        today.setDate(0); // 0 will result in the last day of the previous month
        yyyy = today.getFullYear(); //get the year for the previous month
        mm = today.getMonth() + 1; //get the previous month

        today.setDate(1); // 1 will result in the first day of the previous month

        if (mm === 0) { //if previous month is december, go back 1 year
          
          mm = 12; //and change it to 12 for december
          yyyy = today.getFullYear() - 1;
        }

        dd = this.daysInMonth(mm,yyyy); //get the last day of the previous month (i.e how many days the previous month have)
      
      } 
      // else {

      //   dd = today.getDate();
      // }

      // console.log("PUSHING day: " + dd);
      // console.log("PUSHING MONTH: " + mm);
      // console.log("PUSHING YYYY: " + yyyy);
      // console.log("---------------");

      result.push(
        <ActivityRow
          _id={_this.state._id}
          year={yyyy}
          month={mm}
          day={dd}
          courseID={_this.state.courseID}
          concepts={_this.state.concepts}
        />
      );
    }

    return result;
  },

  renderConceptMasteryRows: function(callback) {

    var _this = this;
    //get the average scores
    // var avgMasterScores = _this.state.avg 

    return (
      <div className="concept-mastery-bars" style={{
        marginTop:'20px'
      }}>
        <ConceptMasteryBar barData={_this.state.excellentData} 
          title={"Excellent"} barHeight={(_this.state.excellentData.length * 30)}
          barColor="#14e838"
          />
        <ConceptMasteryBar barData={_this.state.goodData} 
          title={"Good"} barHeight={(_this.state.goodData.length * 30)}
          barColor="#2ac143"
          />
        <ConceptMasteryBar barData={_this.state.needImprovementData} 
          title={"Need improvement"} barHeight={(_this.state.needImprovementData.length * 30)} 
          barColor="#2f903f"
          />
        <ConceptMasteryBar barData={_this.state.needSpecialAttentionData} 
          title={"Need special attention"} barHeight={(_this.state.needSpecialAttentionData.length * 30)} 
          barColor="#335238"
          />
      </div>
    );
  },

  retrieveConcepts: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    options.tree = true;
    options.max_level = 4;
    options.root = _this.state.courseID;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};

    AnalyticsRes.retrieveStudentConceptMap(options, function(err, res) {

      

      // console.log("CONCEPT MAP DATA IS NOW: ",conceptMapData);
      _this.setState({
        concepts: res, //res,
        // isGettingConcepts: false
      }, ()=> {
        // console.log("res is: ",res);
        _this.retrieveStudentAllTimeStats();
      });
    });
  },


  retrieveStudentAllTimeStats: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};

    options.concept_config = {};
    options.concept_config.root = _this.state.courseID;//_this.state.courseID;//"a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
    options.concept_config.leaf = true;
    options.concept_config.max_level = 4;

    options.conditions = {};

    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    // options.conditions.status = 'student';
    options.skip = 0;
    options.conditions.user = studentID;
    options.conditions.type = "USER_CONCEPT_PRACTICE";

    AnalyticsRes.retrieveStudentAllTimeStats(options, function(err, res) {
      
      //sort the all-time stats (list of concepts that this student has attempted) by mastery score (descending order)
      res.sort(function(a,b) {
        
        if (a.masteryScore>b.masteryScore) { return -1; }
        else if (a.masteryScore < b.masteryScore) { return 1; }
        return 0;
      });
      // console.log("res is now",res);

      _this.setState({

        allTimeStats: res
        // isGettingConcepts: false
      }, ()=> {
        _this.retrieveStudentCurrentCourse();

        // _this.retrieveStudentAggregate();
        // _this.retrieveStudentCurrentCourse();
      });
      // _this.setState({
      //   isGettingConcepts: false
      // });
    });
  },

  retrieveStudentCurrentCourse: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};

    // options.concept_config = {};
    // options.concept_config.root = MATH_ID;//_this.state.courseID;//"a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
    // options.concept_config.leaf = true;
    // options.concept_config.max_level = 4;

    options.include = "item";
    options.conditions0 = {};

    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    // options.conditions.status = 'student';
    options.skip = 0;
    options.conditions0.user = studentID;
    options.conditions0.type = "COURSE_REGISTRATION";

    var conceptsGotten = _this.state.concepts;

    const STYLES = {
      mainTitle: {
        fontSize:24,
        // position:"absolute",
        // top:"1",
        textAlign:"center"
        // float:"top",
        // textAnchor:"top",
        // anchor:"top",
        // paddingTop:120,
        // paddingBottom:400,
        // cx:"0",
        // cy:"10em"
      },
      conceptTitle: {
        fontSize:18,
        textAlign:"center",
        color:"black",
        paddingLeft:80,
        paddingRight:80,
        paddingTop:-200
        // textAlign:"center",
        // textAnchor:"top",
        // anchor:"top"
        // paddingInner:16
      },
      innerConceptTitle: {
        color:"black",
        textAlign:"center",
        // zIndex:99999
      },
      innestConceptTitle: {
        color:"black",
        textAlign:"center",
        paddingTop:20,
        // zIndex:99998
      }
    }
    // var allTimeStats = _this.state.allTimeStats; //get the all time stats so can get the mastery score for each concept (so can color the circles correctly)

    AnalyticsRes.retrieveStudentCurrentCourses(options, function(err, res) {

// console.log("CONCEPT MAP DATA IS NOW: ",conceptsGotten);

      var currentCourses = res[0]; //default to current courses for Math

      var title = "Math";
      if (_this.state.courseID === SCIENCE_ID) { 

        title="Science"; 
        currentCourses = res[1]; //get current courses for science
      }

      // console.log("CONCEPT MAP DATA IS ", conceptMapData);

      _this.setState({

        // concepts: conceptMapData,
        currentCourseInfo: res,
        // isGettingConcepts: false

      }, () => {
        _this.retrieveStudentAggregate();
        // _this.retrieveMathConcepts();
      });
    });
  },

  retrieveStudentAggregate: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.conditions = {};

    //now go through all the concepts and get their ID to add to an array so we can get the aggregate
    var allConcepts = _this.state.allTimeStats;
    var allConceptIDs = [];
    allConcepts.forEach(concept => {
      allConceptIDs.push(concept.concept);
    });
    var newConditions = {
      "concept":{
        "$in":allConceptIDs
      }
    }

    options.conditions = newConditions;

    options.sort = "avgMasteryScore";

    AnalyticsRes.retrieveStudentAggregate(options,function(err,res) {

      //create a new array based on the aggregate averages and this student's sorted mastery score (i.e allTimeStats)
      var conceptMasteryData = [];
      //4 arrays to differentiate the different categories (i.e excellent, good, need improvement or special attention)
      var excellentData = [];
      var goodData = [];
      var needImprovementData = [];
      var needSpecialAttentionData = [];
      var allTimeStats = _this.state.allTimeStats;

      var allConcepts = _this.state.concepts;
      var childLength = allConcepts.children.length;

      var avgLength = res.length;
      allTimeStats.forEach(thisTimeStat => {
        
        //find the avg score for this concept mastery for this student
        var conceptAvgToFind = null;
        for (let x = 0; x < avgLength; x++) {
          
          var avgItem = res[x];
          if (avgItem.concept == thisTimeStat.concept) {
            conceptAvgToFind = avgItem; //found the avg score item for this concept
            break; //break this loop
          }
        }

        //go through all the concepts for current course (either maths or science) to find the concept title
        var thisConceptTitle = "";
        for (let m = 0; m < childLength; m++) {
          
          var thisChild = allConcepts.children[m];
          if (thisChild._id == thisTimeStat.concept) { //if found the concept, retrieve the title
            
            thisConceptTitle = thisChild.title;
            break;
          
          } else { //if not, go through the children of this top children

            var innerChildren = thisChild.children;
            var innerLength = innerChildren.length;
            for (let v = 0; v < innerLength; v++) {

              var innerChild = innerChildren[v];
              if (innerChild._id == thisTimeStat.concept) { //if found the concept in this inner child, get the title

                thisConceptTitle = innerChild.title;
                break;

              } else { //if not, go in deeper to this inner child's children

                var innerMoreChildren = innerChild.children;
                var innerMoreLength = innerMoreChildren.length;
                for (let p = 0; p < innerMoreLength; p++) {
                  
                  var innerMoreChild = innerMoreChildren[p];
                  if (innerMoreChild._id == thisTimeStat.concept) { //if found the concept in this inner child, get the title

                    thisConceptTitle = innerMoreChild.title;
                    break;
    
                  } else { //if still can't find, go in deepest level of children

                    var innerMostChildren = innerMoreChild.children;
                    var innerMostLength = innerMostChildren.length;
                    for (let c = 0; c < innerMostLength; c++) {
                      
                      var innerMostChild = innerMostChildren[c];
                      if (innerMostChild._id == thisTimeStat.concept) {
                        
                        thisConceptTitle = innerMostChild.title;
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
        }



        var newConceptMasteryItem = {
          title:thisConceptTitle,
          studentScore:thisTimeStat.masteryScore,
          average:conceptAvgToFind.avgMasteryScore
        }

        conceptMasteryData.push(newConceptMasteryItem);

        //now we push it into 1 of the 4 categories arrays based on the mastery score for this student (i.e excellent etc)
        if (thisTimeStat.masteryScore >= 0.9) {
          excellentData.push(newConceptMasteryItem);
        } else if (thisTimeStat.masteryScore >= 0.7 && thisTimeStat.masteryScore < 0.9) {
          goodData.push(newConceptMasteryItem);
        } else if (thisTimeStat.masteryScore >= 0.5 && thisTimeStat.masteryScore < 0.7) {
          needImprovementData.push(newConceptMasteryItem);
        } else if (thisTimeStat.masteryScore < 0.5) {
          needSpecialAttentionData.push(newConceptMasteryItem);
        }
      });
    

      // console.log("new mastery data is now",conceptMasteryData);

      _this.setState({
        conceptMasteryData:conceptMasteryData,
        excellentData:excellentData,
        goodData:goodData,
        needImprovementData:needImprovementData,
        needSpecialAttentionData,needSpecialAttentionData,
        allConceptAggregate:res,
        isGettingConcepts: false,
        isLoading:false,
      },()=>{

      });
      
    });

    
  },

  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
              _this  =  this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
      // this.retrieveStudents(function(err, res) {
      // })
    })
  },
  showMath: function(_id) {
    var _this=this;
    this.setState({
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
        courseID: MATH_ID,
        isLoading:true,
    },()=>{
      _this.retrieveConcepts();
    });
  },
  showScience: function(_id) {
    var _this = this;
    this.setState({
        mathButtonStyle: "mistakesButton",
        scienceButtonStyle: "mistakesButton mbSelected",
        courseID: SCIENCE_ID,
        isLoading:true,
    },()=>{
      _this.retrieveConcepts();
    });
  },
  render: function() {
    var _this = this;
    return (
        <div className="students">
            
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo"><h3> {_this.state.progressPageTitle}</h3></label>
                </div>
            </div>
            <hr/>
            <div className="dp-inline-block">
                <button
                    value="Math"
                    onClick={this.showMath.bind(this,_this.state._id)}
                    className={_this.state.mathButtonStyle}
                >Math</button>
            </div>
            <div className="dp-inline-block">
                <button
                    value="Science"
                    onClick={this.showScience.bind(this,_this.state._id)}
                    className={_this.state.scienceButtonStyle}
                >Science</button>
            </div>
            <br/><br/>
            {
              
              (!_this.state.isLoading) &&
              <div className="collection-table mbTable">
                <div className="progressSectionTitle">Progress History</div>
                <table className="table table-bordered table-striped">
                    <thead>
                    {
                        _this.renderHeaderRows()//(this.state.mode.cols)
                    }
                    </thead>
                    
                    {
                      (_this.state.courseID === MATH_ID) &&
                      this.renderActivityRows()
                    }

                    {
                      (_this.state.courseID === SCIENCE_ID) &&
                      this.renderActivityRows()
                    }
                    
                </table>
                <br/>
                <hr/>
                <div className="conceptMasterySection">
                  <div className="progressSectionTitle">Concept Mastery</div>
                  <div className="jumpToConceptMapButtonContainer">
                    <div className="dp-inline-block editStudentButton" title="Concept Map">
                      <Link to={"/student/conceptmap/" + _this.state._id}>View on Concept Map</Link>
                    </div>
                  </div>
                </div>
                  {
                    (_this.state.courseID === MATH_ID) &&
                    _this.renderConceptMasteryRows()
                  }
                  {
                    (_this.state.courseID === SCIENCE_ID) &&
                    _this.renderConceptMasteryRows()
                  }
              </div>
            }
            <br/><br/>
        </div>
    );
  }

});

module.exports = ViewStudentActivity;



/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ViewStudentActivity.js
 **/